import PropTypes from "prop-types";
import { CircleInfoRegularV6 } from "@shared/v2/Icomoon";
import Tooltip from "@shared/v2/Tooltip";

const SELL_SCORE_TOOLTIPS = {
  low: <><b>Low sell score:</b> this property is less likely to be listed than similar nearby properties within the next 6-12 months</>,
  medium: <><b>Medium sell score:</b> this property is equally likely to be listed as similar nearby properties within the next 6-12 months</>,
  high: <><b>High sell score:</b> this property is more likely to be listed than similar nearby properties within the next 6-12 months</>,
};

export const normalizeSellScore = (sellScore) => ({ med: "medium" }[sellScore] || sellScore);

const SellScoreTooltip = ({ sellScore, tooltipClassName }) => {
  const normalizedSellScore = normalizeSellScore(sellScore);

  if (!normalizedSellScore) return null;

  return (
    <Tooltip
      className="tw-pl-[8px] tw-flex tw-items-center"
      placement="right"
      innerClassName="tw-max-w-[258px] !tw-text-left"
      trigger={<CircleInfoRegularV6 className={`tw-text-gray-75 ${tooltipClassName || ""}`} />}
      content={SELL_SCORE_TOOLTIPS[normalizedSellScore] || `Sell Score: ${normalizedSellScore}`}
    />
  );
};

SellScoreTooltip.propTypes = {
  sellScore: PropTypes.string,
  tooltipClassName: PropTypes.string,
};

SellScoreTooltip.defaultProps = {
  sellScore: "",
  tooltipClassName: "",
};

export default SellScoreTooltip;
